import useStyles from "../RelatedPaymentTooltip/styles";
import React, { FC } from "react";
import Typography from "@material-ui/core/Typography";
import { DPDivider } from "Components/DP";
import { PaySpan } from "Shared/types/Payments";
import pretty from "Shared/pretty";

const RelatedPaymentTooltipTitle: FC<PaySpan> = ({
  totalAmount,
  thisAmount,
  prevAmount,
  nextAmount,
  otherAmount,
}) => {
  const amountsAndLabels = [
    { amount: thisAmount, label: "This Period:" },
    { amount: prevAmount, label: "Previous Period:" },
    { amount: nextAmount, label: "Next Period:" },
    { amount: otherAmount, label: "Other:" },
  ];
  const classes = useStyles();

  const getRelatedPaymentTypography = (amount: number, label: string) => {
    return (
      !!amount && (
        <Typography key={label} variant="body1">
          {label}
          <span className={classes.rightText}>{pretty.dollar(amount)}</span>
        </Typography>
      )
    );
  };

  return (
    <>
      <Typography variant="body1">
        <b>Payment Summary</b>
      </Typography>
      <br />

      <Typography variant="body2">
        User made a {pretty.dollar(totalAmount)} transfer. The amount was split
        between the following pay periods:
      </Typography>
      <br />
      {amountsAndLabels.map(amountAndLabel =>
        getRelatedPaymentTypography(amountAndLabel.amount, amountAndLabel.label)
      )}
      <DPDivider margin="condensed" />
      <Typography variant="body1">
        <b>
          Total Transfer:
          <span className={classes.rightText}>
            {pretty.dollar(totalAmount)}
          </span>
        </b>
      </Typography>
    </>
  );
};

export default RelatedPaymentTooltipTitle;
